import { SUPPORTED_LANGUAGES } from "@/constants/supported_languages";
import { LangDetails, SupportedLocale } from "@/types";

export function detectLanguage(): LangDetails {
  // Check if the locale is stored in localStorage
  let locale = localStorage.getItem("locale") as SupportedLocale | null;
  let localeDetails = SUPPORTED_LANGUAGES[locale as SupportedLocale];

  if (localeDetails) {
    return localeDetails;
  }

  // Fallback to browser language if not found in localStorage
  locale = navigator.language.split("-")[0] as SupportedLocale;
  localeDetails = SUPPORTED_LANGUAGES[locale];

  if (localeDetails) {
    return localeDetails;
  }

  // Fallback to English if no match found
  return SUPPORTED_LANGUAGES.en;
}

export default detectLanguage;
